// extracted by mini-css-extract-plugin
export var footerSponsors = "sponsors-module--footerSponsors--KCd0V";
export var footerSponsors__content = "sponsors-module--footerSponsors__content--lufh3";